import { media, styled } from '@styles';
import crossIcon from 'images/close.svg';
import { Button } from '@components/atoms/Button';

export const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  max-width: calc(425px + 33px * 2);
  position: relative;
  margin: 0 auto;
  padding: 0 33px;
  overflow-y: auto;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    width: 0px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: ${(props) => props.theme.typography.smallFontSize};
  line-height: ${(props) => props.theme.typography.smallFontSize};
  letter-spacing: 3px;
  text-transform: uppercase;
  width: 100%;
  border: none;
  padding-bottom: 0;
  margin-bottom: 34px;
  margin-top: 44px;
`;

export const ActiveFilters = styled.div`
  width: 24px;
  height: 24px;
  font-size: ${(props) => props.theme.typography.labelFontSize};
  ${media.largeScreen`
    width: 18px;
    height: 18px;
  `}
  color: #ffffff;
  border-radius: 50%;
  background-color: #000000;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
  span {
    transform: translateX(0.1em);
  }
`;

export const FilterGroup = styled.div`
  margin-bottom: 50px;
  width: 100%;
  ${media.largeScreen`
    margin-bottom: 36px;
  `}
  ${media.mediumScreen`
    margin-bottom: 50px;
  `}
  ${media.xSmallScreen`
    margin-bottom: 36px;
  `}
`;

export const ButtonFilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 200px;
  align-items: center;
  justify-content: flex-start;
`;

export const FilterTitle = styled.div`
  color: ${(props) => props.theme.colors.baseFont};
  font-size: ${(props) => props.theme.typography.baseFontSize};
  margin-bottom: 20px;
  line-height: 1.2em;
  ${media.mediumScreen`
    margin-bottom: 20px;
  `}
  ${media.xSmallScreen`
    margin-bottom: 10px;
  `}
`;

export const ClearButton = styled.button`
  font-weight: 500;
  font-size: ${(props) => props.theme.typography.baseFontSize};
  line-height: normal;
  color: #bdbdbd;
  ${media.mediumScreen`
    margin-bottom: 32px;
  `}
`;

export const DoneButton = styled(Button)`
  font-size: ${(props) => props.theme.typography.labelFontSize};
  line-height: 13px;
  min-width: 230px;
  margin-bottom: 32px;
  display: none;
  ${media.mediumScreen`
    display: block;
  `}
`;

export const CloseButton = styled.button`
  display: block;
  background-image: url(${crossIcon});
  width: 24px;
  height: 24px;
  position: absolute;
  top: 40px;
  right: 40px;
  z-index: 1;

  ${media.xSmallScreen`
    top: 20px;
    right: 20px;
  `}
`;
